<template>
  <v-container>

    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Crypto Trades
            <v-spacer></v-spacer>
            <form v-on:submit.prevent="reload">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                hide-details></v-text-field>
            </form>

            <v-menu offset-y v-model="menu" :close-on-content-click="false" :close-on-click="true">
              <template v-slot:activator="{ on }">
                <v-btn class="primary" v-on="on">Filter <v-icon right dark>
                    mdi-filter-variant
                  </v-icon></v-btn>
              </template>
              <v-card class="pa-5" flat>
                <label for="">Wallet</label>
                <v-select :items="coins" v-model="wallet" item-text="coinName" item-value="id" dense outlined
                  return-object></v-select>
                <label for="">Status</label>
                <v-select :items="['approved', 'declined', 'processing']" v-model="status" dense outlined
                  return-object></v-select>
                <label for="">Date</label>
                <br />
                <DateRangePicker v-model="dateRange" />
                <v-card-actions>
                  <v-btn rounded depressed @click="reset">Reset</v-btn>
                  <v-btn color="primary" @click="reload()" rounded depressed>Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-card-title>
          <template>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Coin
                    </th>
                    <th class="text-left">
                      Name
                    </th>
                    <th class="text-left">
                      Transaction ID
                    </th>
                    <th class="text-left">
                      Amount ($)
                    </th>
                    <th class="text-left">
                      Amount (N)
                    </th>
                    <th class="text-left">
                      Quantity
                    </th>
                    <th class="text-left">
                      Date
                    </th>
                    <th class="text-left">
                      Status
                    </th>
                    <th class="text-left">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in trades" :key="item.id">
                    <td>
                      <div class="logo-container">
                        <img :src="item.coin.logoURL" alt="Your Logo">
                        <span class="logo-text">{{ item.coin.coinShortName }}</span>
                      </div>
                    </td>
                    <td>{{ item.user.profile.firstname + ' ' + item.user.profile.lastname }}</td>
                    <td>
                      <a v-if="item.coin.coinShortName == 'BTC'" target="_blank"
                        :href="'https://blockchair.com/bitcoin/transaction/' + item.hash">{{ item.reference }} </a>
                      <a v-if="item.coin.coinShortName == 'ETH'" target="_blank"
                        :href="'https://etherscan.io/search?f=0&q=' + item.hash">{{ item.reference }} </a>
                      <a v-if="item.coin.coinShortName == 'LTC'" target="_blank"
                        :href="'https://live.blockcypher.com/ltc/tx/' + item.hash">{{ item.reference }} </a>
                      <a v-if="item.coin.coinShortName == 'BNB'" target="_blank"
                        :href="'https://bscscan.com/tx/' + item.hash">{{ item.reference }} </a>
                      <a v-if="item.coin.coinShortName == 'USDTTRC20'" target="_blank"
                        :href="'https://tronscan.org/#/transaction/' + item.hash">{{ item.reference }} </a>
                        <a v-if="item.coin.coinShortName == 'USDC'" target="_blank"
                        :href="'https://etherscan.io/search?f=0&q=' + item.hash">{{ item.reference }} </a>
                    </td>
                    <td>{{ formatMoney(item.amount_usd) }}</td>
                    <td>{{ formatMoney(item.amount_naira) }}</td>
                    <td>{{ item.amount }}</td>

                    <td>{{ formatDateDisplay(item.created) }}</td>

                    <td>
                      <v-chip v-if="item.status === 'approved'" class="ma-2" color="success">
                        {{ item.status }}
                      </v-chip>
                      <v-chip v-if="item.status == 'declined'" class="ma-2" color="red">
                        {{ item.status }}
                      </v-chip>
                      <v-chip v-if="item.status == 'pending' || item.status == 'processing'" class="ma-2" color="primary">
                        {{ item.status }}
                      </v-chip>
                    </td>
                    <td>
                      <template v-if="item.status == 'pending' || item.status == 'processing'">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-dots-vertical</v-icon>
                          </template>
                          <v-list>
                            <v-list-item v-for="(text, index) in items" :key="index" @click="handleClick(text)">
                              <v-list-item-title><security-pin-modal :item="item" :text="text">{{ text
                              }}</security-pin-modal></v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </template>
                      <v-icon style="color:green" v-if="item.status == 'approved'">
                        mdi-check
                      </v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>

            </v-simple-table>
            <v-row>
              <v-col>
                <v-pagination v-model="page" :length="count" @input="loadTrades" rounded="circle"></v-pagination>
              </v-col>
            </v-row>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
 
 
<script>

// import sound from '@/assets/Global/Sounds/notify.wav'

import DateRangePicker from "@/components/DateRangePicker.vue";

// =========== IMPORT SERVICE =========
import { CryptoService } from "@/services";
import SecurityPinModal from "../components/security-pin-modal.vue";
import { formatMoney } from '@/utils/moneyFormatter';
import app from '@/main'
import moment from 'moment'

export default {
  data: () => ({
    dateRange: {},
    items: ['approve', 'decline'],
    search: '',
    status: '',
    pinModal: 0,
    count: 0,
    dialog: false,
    coins: [],
    wallet: '',
    coinName: [],
    trades: [],
    page: 1,
    limit: 10,
    menu: false,
  }),
  async mounted() {
    this.loadTrades(),
      this.getAllCoins();
  },
  methods: {
    closeModal() {
      this.dialog = false;
    },
    pad(num) {
      return num < 10 ? `0${num}` : num;
    },
    async refresh() {
      this.pinModal = 0;
      this.loadTrades();
      this.getAllCoins();
      setTimeout(() => {
        this.pinModal = 0
      }, 1000)
    },
    formatDateDisplay(dateString) {
      return moment(dateString).format('MMMM Do YYYY, h:mm:ss a')
    },
    async loadTrades() {
      try {
        const filter = {
          page: this.page, limit: this.limit,
          start_date: this.dateRange.startDate, end_date: this.dateRange.endDate,
          search: this.search, coin_short_name: this.wallet.coinShortName,
          status: this.status
        };
        let data = await CryptoService.loadCoinTrades(this.cleanUpFilter(filter));
        if (data) {
          this.trades = data.trades;
          this.count = Math.ceil(Number(data.total / this.limit));

        }
      } catch (error) {
        app.$store.dispatch('toast', {
          message: 'something went wrong',
          variant: 'error'
        })
      }
    },
    async reload() {
     this.page = 1;
      await this.loadTrades();
      this.menu = false;
    },
    async reset() {
      this.search = '';
      this.dateRange = {};
      this.wallet = '';
      this.page = 1;
      this.limit = 10;
      this.status = '';
      this.loadTrades();
      this.menu = false;
    },
    async getAllCoins() {
      this.loading = true;
      let data = await CryptoService.getCoins();
      if (data) {
        this.loading = false;
        this.coins = data;


      }
    },
    cleanUpFilter(obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === "") {
          delete obj[key];
        }
      });
      let check = Object.keys(obj).length === 0;
      return check ? null : obj;
    },
    formatMoney(amount){
      return formatMoney(amount, false)
    },
    handleClick() {

    }
  },
  components: {
    DateRangePicker,
    SecurityPinModal
  },
  watch: {
    search (value) {
      if (!value) {
        this.reload()
      }
    },
  }
};
</script>

<style>
.logo-container {
  display: flex;
  align-items: center;
}

.logo-container img {
  margin-right: 10px;
  width: 20px;
  height: 20px;
  /* add margin if necessary */
}

.logo-text {
  font-size: 18px;
  /* adjust font size as needed */
}
</style>